import type { Role } from '@domain/entities';
import type { IRoleRepository } from '@domain/repositories';
import type { PaginatedResult, RoleFilters } from '@application/dto';

export class ListRolesUseCase {
  constructor(private readonly roleRepository: IRoleRepository) {}

  async execute(filters: RoleFilters): Promise<PaginatedResult<Role>> {
    return this.roleRepository.list(filters);
  }
}
